import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const staffApi = createApi({
  reducerPath: 'staffApi',
  baseQuery: rtkBaseQuery('/staff/Staff'),
  providesTags: ['Stafflist', 'OrgChart', 'Staff', 'InternalDocuments'],
  endpoints: (builder) => ({
    staffList: builder.mutation({
      query: ({ name, ...body }) => {
        return {
          url: `/StaffsList${name ? '?name=' + name : ''}`,
          method: 'POST',
          body,
        };
      },
    }),
    getStaffList: builder.query({
      query: () => '/StaffsListAll',
      providesTags: ['Stafflist'],
      // transformResponse: (response) => response.items,
    }),
    getAllEmployees: builder.query({
      query: (params) => ({
        url: '/GetEmployees',
        params,
      }),
      invalidatesTags: ['Staff'],
    }),
    getListOfStaffs: builder.mutation({
      query: (params) => ({
        url: '/GetStaffsList',
        method: 'POST',
        params,
      }),
    }),
    staffBirthdayListByDate: builder.mutation({
      query: (params) => ({
        url: '/StaffBirthdayListByDate',
        method: 'POST',
        params,
      }),
    }),
    getStaffBdayToday: builder.mutation({
      query: () => ({
        url: '/StaffBirthdayListByDate',
        method: 'POST',
        params: { date: new Date().toISOString() },
      }),
    }),
    getStaffFromHRM: builder.mutation({
      query: (body) => ({
        url: '/getStaffFromHRM',
        method: 'POST',
        body,
      }),
    }),
    getTemplateFileList: builder.query({
      query: () => '/GetTemplateFileList',
    }),
    staffById: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/StaffByIdV2/${id}`,
        method: 'POST',
        body,
      }),
      providesTags: (result, error, { id }) => [{ type: 'Staff', id }],
    }),
    onSaveStaff: builder.mutation({
      query: (body) => ({
        url: '/onSaveStaff',
        method: 'POST',
        body,
      }),
    }),
    onSaveProfile: builder.mutation({
      query: (body) => ({
        url: '/onSaveProfile',
        method: 'POST',
        body,
      }),
    }),
    getOrgChart: builder.query({
      query: () => '/GetOrgChart2',
      providesTags: ['OrgChart'],
    }),
    getPositionsByDepartmentNew: builder.query({
      query: (id) => `/GetPositionsByDepartmentNew?hrmid=${id}`,
    }),
    getOrgUnitList: builder.query({
      query: () => '/GetOrgUnitList',
    }),
    createOrgUnit: builder.mutation({
      query: (body) => ({
        url: '/CreateOrgUnit',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['OrgChart'],
    }),
    deleteOrgUnit: builder.mutation({
      query: (id) => ({
        url: `/DeleteOrgUnit?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['OrgChart'],
    }),
    editOrgUnit: builder.mutation({
      query: (body) => ({
        url: '/EditOrgUnit',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['OrgChart'],
    }),
    moveOrgUnit: builder.mutation({
      query: ({ orgUnitId, move }) => ({
        url: `/MoveOrgUnit?orgUnitId=${orgUnitId}&move=${move}`,
        method: 'POST',
      }),
      invalidatesTags: ['OrgChart'],
    }),
    createScheduleOfStaff: builder.mutation({
      query: (body) => ({
        url: '/CreateScheduleOfStaff',
        method: 'POST',
        body,
      }),
    }),
    deleteScheduleOfStaff: builder.mutation({
      query: (body) => ({
        url: '/DeleteScheduleOfStaff',
        method: 'POST',
        body,
      }),
    }),
    editScheduleOfStaff: builder.mutation({
      query: (body) => ({
        url: '/EditScheduleOfStaff',
        method: 'POST',
        body,
      }),
    }),
    getScheduleOfStaff: builder.query({
      query: () => '/GetScheduleOfStaff',
    }),
    getBase64ImageById: builder.mutation({
      query: (id) => ({
        url: `/GetStringBase64ById?id=${id}`,
        method: 'POST',
      }),
    }),
    getBase64VideoById: builder.mutation({
      query: (id) => ({
        url: `/GetStringBase64ByIdVideo?id=${id}`,
        method: 'POST',
      }),
    }),
    uploadFileForDb: builder.mutation({
      query: (body) => ({
        url: '/UploadFileForDb',
        method: 'POST',
        body,
      }),
    }),
    uploadFileForFolder: builder.mutation({
      query: (body) => ({
        url: '/UploadFileForFolder',
        method: 'POST',
        body,
      }),
    }),
    getAllSkills: builder.query({
      query: () => ({
        url: '/GetSkillList',
      }),
    }),
    addSkillsToUser: builder.mutation({
      query: (body) => ({
        url: '/AddSkillToStaff',
        method: 'POST',
        body,
      }),
    }),
    getUpcomingBirthdays: builder.query({
      query: () => ({ url: 'GetUpcomingEmployeeBirthdayList' }),
    }),
    getTodayBirthdays: builder.query({
      query: () => ({ url: 'GetTodayEmployeeBirthdayList' }),
    }),
    getPhotoFromHrm: builder.query({
      query: ({ staffId }) => ({
        url: `GetPhotoFromHrm?staffId=${staffId}`,
      }),
    }),
    getAbsences: builder.query({
      query: () => '/GetAbsences',
    }),
    getAbsencesByType: builder.query({
      query: (params) => ({
        url: '/GetAbsencesByType',
        params,
      }),
      providesTags: ['Staff'],
    }),
    getNameByStaffId: builder.query({
      query: ({ Id }) => ({
        url: `GetNameByStaffId?Id=${Id}`,
      }),
    }),
    deleteFile: builder.mutation({
      query: ({ id }) => ({
        url: `/DeleteFile?fileId=${id}`,
        method: 'DELETE',
      }),
    }),
    updateFile: builder.mutation({
      query: ({ id, formData }) => ({
        url: '/UpdateFile',
        method: 'PUT',
        params: { Id: id },
        body: formData,
      }),
    }),
    getDataForVisitCard: builder.query({
      query: ({ id }) => `/GetDataForQR?Id=${id}`,
    }),
    getInternalFileList: builder.query({
      query: () => '/GetInternalFileList',
      providesTags: ['InternalDocuments'],
    }),
    getTopList: builder.query({
      query: () => '/GetTopsList',
    }),
    getDepartmentsByStaffId: builder.query({
      query: () => '/GetDepartmentsByStaffId',
    }),
    getMainDirector: builder.query({
      query: () => '/GetMainDirector',
    }),
  }),
});

export const {
  useStaffListMutation,
  useGetStaffListQuery,
  useGetAllEmployeesQuery,
  useGetListOfStaffsMutation,
  useStaffBirthdayListByDateMutation,
  useGetTemplateFileListQuery,
  useStaffByIdMutation,
  useOnSaveStaffMutation,
  useOnSaveProfileMutation,
  useGetOrgChartQuery,
  useGetPositionsByDepartmentNewQuery,
  useGetOrgUnitListQuery,
  useCreateOrgUnitMutation,
  useDeleteOrgUnitMutation,
  useEditOrgUnitMutation,
  useMoveOrgUnitMutation,
  useCreateScheduleOfStaffMutation,
  useDeleteScheduleOfStaffMutation,
  useEditScheduleOfStaffMutation,
  useGetScheduleOfStaffQuery,
  useGetBase64ImageByIdMutation,
  useGetBase64VideoByIdMutation,
  useUploadFileForDbMutation,
  useUploadFileForFolderMutation,
  useGetStaffFromHRMMutation,
  useGetAllSkillsQuery,
  useAddSkillsToUserMutation,
  useGetStaffBdayTodayMutation,
  useGetUpcomingBirthdaysQuery,
  useGetTodayBirthdaysQuery,
  useGetPhotoFromHrmQuery,
  useGetAbsencesQuery,
  useGetAbsencesByTypeQuery,
  useGetNameByStaffIdQuery,
  useDeleteFileMutation,
  useUpdateFileMutation,
  useGetDataForVisitCardQuery,
  useGetInternalFileListQuery,
  useGetTopListQuery,
  useGetDepartmentsByStaffIdQuery,
  useGetMainDirectorQuery,
} = staffApi;
